import { useTheme } from '@emotion/react';

import Svg from '../svg/Svg';

import { GraphicProps } from './type';

const GraphicCarrier = ({ isAct = false, ...rest }: GraphicProps) => {
  const theme = useTheme();

  return (
    <Svg {...rest}>
      <g clipPath="url(#clip0_2627_61616)">
        <path
          d="M10.0781 1.86914H11.1302V11.461H10.0781V1.86914Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M13.7812 1.86914H14.8333V11.461H13.7812V1.86914Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M9.76821 2.56445C9.4777 2.56445 9.24219 2.35295 9.24219 2.09204L9.24219 1.64363C9.24219 1.38273 9.4777 1.17122 9.76821 1.17122L15.1602 1.17122C15.4507 1.17122 15.6862 1.38273 15.6862 1.64363L15.6862 2.09204C15.6862 2.35295 15.4507 2.56445 15.1602 2.56445L9.76821 2.56445Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.87303 23.1708C9.5321 23.1708 10.0664 22.691 10.0664 22.0991C10.0664 21.5072 9.5321 21.0273 8.87303 21.0273C8.21397 21.0273 7.67969 21.5072 7.67969 22.0991C7.67969 22.691 8.21397 23.1708 8.87303 23.1708ZM8.87311 22.3586C9.03289 22.3586 9.16241 22.2423 9.16241 22.0988C9.16241 21.9553 9.03289 21.839 8.87311 21.839C8.71334 21.839 8.58382 21.9553 8.58382 22.0988C8.58382 22.2423 8.71334 22.3586 8.87311 22.3586Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7793 23.1727C16.4383 23.1727 16.9726 22.6929 16.9726 22.101C16.9726 21.5091 16.4383 21.0293 15.7793 21.0293C15.1202 21.0293 14.5859 21.5091 14.5859 22.101C14.5859 22.6929 15.1202 23.1727 15.7793 23.1727ZM15.7794 22.3606C15.9391 22.3606 16.0687 22.2443 16.0687 22.1008C16.0687 21.9573 15.9391 21.841 15.7794 21.841C15.6196 21.841 15.4901 21.9573 15.4901 22.1008C15.4901 22.2443 15.6196 22.3606 15.7794 22.3606Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M7.80202 22.1152C6.78522 22.1152 5.96094 21.375 5.96094 20.4618L5.96094 8.202C5.96094 7.28883 6.78522 6.54856 7.80202 6.54856L17.1199 6.54856C18.1367 6.54856 18.9609 7.28883 18.9609 8.202L18.9609 20.4618C18.9609 21.375 18.1367 22.1152 17.1199 22.1152L7.80202 22.1152Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M11.8594 9.05005C11.8594 8.68478 12.1891 8.38867 12.5958 8.38867C13.0025 8.38867 13.3322 8.68478 13.3322 9.05005V19.5848C13.3322 19.9501 13.0025 20.2462 12.5958 20.2462C12.1891 20.2462 11.8594 19.9501 11.8594 19.5848V9.05005Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M8.17969 9.05005C8.17969 8.68478 8.5094 8.38867 8.91612 8.38867C9.32284 8.38867 9.65256 8.68478 9.65256 9.05005V19.5848C9.65256 19.9501 9.32284 20.2462 8.91612 20.2462C8.5094 20.2462 8.17969 19.9501 8.17969 19.5848V9.05005Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M15.5391 9.05005C15.5391 8.68478 15.8688 8.38867 16.2755 8.38867C16.6822 8.38867 17.0119 8.68478 17.0119 9.05005V19.5848C17.0119 19.9501 16.6822 20.2462 16.2755 20.2462C15.8688 20.2462 15.5391 19.9501 15.5391 19.5848V9.05005Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
      </g>
      <defs>
        <clipPath id="clip0_2627_61616">
          <rect width="13" height="22.0015" fill="white" transform="translate(5.96094 1.17188)" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default GraphicCarrier;
